module.exports = __webpack_public_path__ + "img/suitecase.1522ca94.svg";